import CdtResultCard from "../components/personas/CDTs/LateralListado1";
import CdtListItem from "../components/personas/CDTs/CdtListItem";
import robot1 from "../assets/robot1.png";
import barrasimulador from "../assets/barrasimulador.png";
import ban100popupimage from "../assets/ban100popupimage.png";
import { useState } from "react";
import Filtro from "../components/personas/CDTs/Filtro";
import Carousel from "../components/Carousel2";
import FAQSection from "../components/personas/CDTs/FAQ";
import { useNavigate } from "react-router-dom";


function SimuladorCDT({ nombre = "Usuario" }) {

    const [selected, setSelected] = useState("6 meses");
    const [showInvestmentPopup, setShowInvestmentPopup] = useState(false);
    const [showCodePopup, setShowCodePopup] = useState(false);
    const navigate = useNavigate();
    const goToSupport = () => navigate("/vincula-tus-finanzas");

    const handleSelect = (option) => {
        setSelected(option);
    };

    const openInvestmentPopup = () => {
        setShowInvestmentPopup(true);
        setShowCodePopup(false);
    };

    const openCodePopup = () => {
        setShowInvestmentPopup(false);
        setShowCodePopup(true);
    };

    const closePopups = () => {
        setShowInvestmentPopup(false);
        setShowCodePopup(false);

    };


    return (
        <div>
            <div className="bg-[#0346a4] min-h-screen px-[8%] py-10 relative overflow-hidden">
                <img src={robot1} alt="Robot" className="absolute top-0 left-100 ml-40 mt-20 w-full max-w-[1500px] h-auto" />
                <img src={robot1} alt="Robot" className="absolute bottom-0 right-0 w-full max-w-[1500px] h-auto" />

                <h1 className="text-white font-extrabold text-4xl mb-4 relative z-10">
                    Elige el que más se ajuste a ti, {nombre}
                </h1>
                <div className="bg-[#e8f2f4] p-4 rounded-lg mb-6 max-w-[1000px] relative z-10">
                    <img src={barrasimulador} alt="Barra simulador" className="w-full" />
                </div>

                <div className="flex relative z-10 space-x-7">
                    <div className="flex-[1_1_25%]">
                        <CdtResultCard />
                        <Filtro />
                    </div>
                    <div className="flex-[1_1_70%] bg-[#e8f2f4] p-6 rounded-2xl shadow-lg ml-6">
                        <h2 className="text-[#0346a4] font-extrabold text-4xl mb-4">Los bancos ofrecen:</h2>
                        <div className="flex items-center space-x-4 mb-6">
                            <p className="text-[#0346a4] font-bold text-2xl">Ordena por plazo:</p>
                            <div className="flex space-x-2">
                                {["6 meses", "12 meses", "18 meses"].map((option) => (
                                    <button
                                        key={option}
                                        onClick={() => handleSelect(option)}
                                        className={`px-4 py-2 rounded-lg font-bold shadow-[0px_2px_4px_rgba(0,0,0,0.4)] ${selected === option ? "bg-[#004cb6] text-white" : "bg-white text-[#004cb6]"}`}
                                    >
                                        {option}
                                    </button>
                                ))}
                            </div>
                        </div>

                        <div className="space-y-4 font-bold">
                            <CdtListItem openInvestmentPopup={openInvestmentPopup} />
                            <CdtListItem openInvestmentPopup={openInvestmentPopup} />
                            <CdtListItem openInvestmentPopup={openInvestmentPopup} />
                        </div>
                    </div>
                </div>
            </div>

            <Carousel />
            <FAQSection />

            {/* Popup de Confirmación de Inversión */}
            {showInvestmentPopup && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" onClick={(e) => { if (e.target === e.currentTarget) closePopups(); }}>
                    <div className="bg-[#e8f2f4] rounded-xl px-6 pt-10 pb-4 w-[500px] text-center relative">
                        <button onClick={closePopups} className="absolute top-2 right-2 text-[#033a88] text-2xl font-bold hover:text-[#022351]">
                            ✕
                        </button>
                        <h2 className="text-[#004cb6] text-2xl font-bold mb-4">Confírmanos tus datos de inversión con</h2>
                        <img src={ban100popupimage} alt="Ban100" className="w-40 mb-4" />
                        <div className="grid grid-cols-2 gap-4 mb-4">
                            <div>
                                <p className="text-left text-[#004cb6] font-bold">Tu inversión por</p>
                                <input type="text" defaultValue="$5.000.000" className="w-full p-2 bg-[#cfe3fb] rounded-lg" />
                            </div>
                            <div>
                                <p className="text-left text-[#004cb6] font-bold">Que me entregará</p>
                                <div className="bg-[#36a31a] text-white font-bold p-2 rounded-lg">$5.815.709</div>
                            </div>
                            <div>
                                <p className="text-left text-[#004cb6] font-bold">Por esperar un plazo de</p>
                                <select
                                    defaultValue="18 meses"
                                    className="text-[#032c65] w-full p-2 bg-[#cfe3fb] rounded-lg"
                                >
                                    <option value="6 meses">6 meses</option>
                                    <option value="12 meses">12 meses</option>
                                    <option value="18 meses">18 meses</option>
                                </select>
                            </div>
                            <div>
                                <p className="text-left text-[#004cb6] font-bold">A una rentabilidad del</p>
                                <div className="bg-[#36a31a] text-white font-bold p-2 rounded-lg">10.6% EA</div>
                            </div>
                        </div>
                        <button onClick={openCodePopup} className="bg-[#36a31a] text-white font-bold py-2 px-6 rounded-lg w-full mt-4 hover:bg-[#55b03e]">
                            Confirmar datos
                        </button>
                        <div className="mt-2 bg-transparent rounded-lg w-full text-center">
                            <button
                                type="button"
                                onClick={goToSupport}
                                className="text-[#2860ad] text-sm font-bold hover:underline focus:outline-none"
                            >
                                ¿Necesitas ayuda? Escríbenos aquí.
                            </button>
                        </div>
                    </div>
                </div>
            )}


            {/* Popup de Ingreso de Código */}
            {showCodePopup && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" onClick={(e) => { if (e.target === e.currentTarget) closePopups(); }}>
                    <div className="bg-[#e8f2f4] rounded-xl px-6 pt-10 pb-4 w-[500px] relative">
                        <h2 className="text-[#03295d] text-3xl font-bold mb-4">Ingresa el código</h2>
                        <button onClick={closePopups} className="absolute top-2 right-2 text-[#033a88] text-2xl font-bold hover:text-[#022351]">✕</button>

                        <p className="text-[#0050bf] font-bold text-2xl">Que te enviamos a tu celular terminado en ****758. Te lo enviamos por WhatsApp y Mensaje de Texto 😊</p>

                        <div className="flex justify-center gap-2 my-6">
                            {[...Array(6)].map((_, index) => (
                                <input
                                    key={index}
                                    type="text"
                                    maxLength="1"
                                    className="w-12 h-12 text-center text-2xl font-bold bg-white rounded-lg shadow-md border border-gray-300"
                                    onChange={(e) => {
                                        const { value } = e.target;
                                        if (value.match(/[0-9]/)) {
                                            if (e.target.nextSibling) {
                                                e.target.nextSibling.focus();
                                            }
                                        } else {
                                            e.target.value = "";
                                        }
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === "Backspace" && e.target.previousSibling) {
                                            e.target.previousSibling.focus();
                                        }
                                    }}
                                />
                            ))}
                        </div>

                        <button onClick={() => navigate("/personas/cdt/vamos-a-iniciar")} className="bg-[#36a31a] text-white font-bold py-2 px-6 rounded-lg w-full mt-4 hover:bg-[#55b03e]">Siguiente</button>

                        <div className="mt-2 bg-transparent rounded-lg w-full text-center">
                            <button
                                type="button"
                                onClick={goToSupport}
                                className="text-[#2860ad] text-sm font-bold hover:underline focus:outline-none"
                            >
                                ¿Necesitas ayuda? Escríbenos aquí.
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
}

export default SimuladorCDT;
